// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SymbolsPage_wrapper_3s2kD"};